import { create } from 'zustand';

// Empêche la reconnexion biométrique automatique au prochain affichage de
// l'écran de connexion : utilisé juste après une déconnexion explicite
// demandée par l'utilisateur (le "Se déconnecter" doit vraiment déconnecter,
// pas relancer une reconnexion silencieuse). Flag en mémoire uniquement,
// consommé une seule fois — la déconnexion automatique par inactivité ne
// le pose pas, elle continue de bénéficier de la reconnexion biométrique.
interface BiometricAutoLoginStore {
  suppressed: boolean;
  suppressAutoLogin: () => void;
  consumeSuppression: () => boolean;
}

export const useBiometricAutoLoginStore = create<BiometricAutoLoginStore>((set, get) => ({
  suppressed: false,
  suppressAutoLogin: () => set({ suppressed: true }),
  consumeSuppression: () => {
    const wasSuppressed = get().suppressed;
    if (wasSuppressed) set({ suppressed: false });
    return wasSuppressed;
  },
}));
